import { Pipe, PipeTransform } from '@angular/core';
import { HashMap } from '@ngneat/transloco';
import { CommonWordingPipe } from '@platform-frontend/ui-tools';
import { Observable } from 'rxjs';
import { ACCOUNT_UI_TRANSLOCO_SCOPE } from '../account-ui-transloco-scope';
import { CommonUserProfileWording } from './model/common-user-profile-wording';

@Pipe({
  name: 'commonUserProfileWording'
})
export class CommonUserProfileWordingPipe extends CommonWordingPipe<CommonUserProfileWording> implements PipeTransform {
  transform(value: CommonUserProfileWording, params: HashMap = {}): Observable<string> {
    return super.transform(value, params, ACCOUNT_UI_TRANSLOCO_SCOPE, 'userProfileInformation.');
  }
}
